import type { WebColor } from '@/UI/ColorPicker/ColorPicker';
import type { ParameterValue } from 'web';

export function vecToWebColor(value: readonly number[]): WebColor {
  return {
    r: Math.round(value[0] * 255),
    g: Math.round(value[1] * 255),
    b: Math.round(value[2] * 255),
    a: value.length > 3 ? value[3] : 1,
  };
}

export function webColorToVec(color: WebColor, hasAlpha: boolean): Extract<ParameterValue, { type: 'vec3' | 'vec4' }> {
  return hasAlpha
    ? { type: 'vec4', value: [color.r / 255, color.g / 255, color.b / 255, color.a] }
    : { type: 'vec3', value: [color.r / 255, color.g / 255, color.b / 255] };
}
